/**
 * Add this component to entities that you want to color
 */
class EntityColorComponent {
    constructor(color) {
        this.typeId = EntityColorComponent.id;
        this.doStoreInSnapshot = true;
        this.serializable = false;
        this.color = color;
    }
    eq(other) {
        return this.color === other.color;
    }
}
EntityColorComponent.id = 2064;
export default EntityColorComponent;
//# sourceMappingURL=EntityColorComponent.js.map